export default __webpack_public_path__ + "static/john-oglevee-c856eab56b2d84938227c647e99fd142.jpg";